export enum BetslipType {
  American = 'AMERICAN',
  Standard = 'STANDARD',
}
